import { useTranslation } from 'next-i18next'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import html from 'html-react-parser'

import 'swiper/css'
import 'swiper/css/navigation'
import Title from '@/components/common/Title'
import { Grid } from '@/styles/grid'

import { Text1 } from '@/styles/typography'

import CustomReveal from '@/components/common/CustomReveal'

import { useMarket } from '@/utils/multi-markets/context'

import CommonButton from '../form/Button/CommonButton'

import BtnGlobalCustomStyles from '../form/Button/button.customStyles'

import { HOW_IT_WORKS_ICONS, StepIconKey } from './howItWorksAssets'

import {
  ButtonNext,
  ButtonPrev,
  Buttons,
  Container,
  Content,
  StepIcon,
  IconWrapper,
  InfoText,
  LineWrapper,
  TitleWrapper
} from './HowItWorks.styled'

function HowItWorks() {
  const { t } = useTranslation('navipay')
  const { locale } = useMarket()

  const isRTL = locale === 'ar'

  const steps = [
    {
      iconUrl: HOW_IT_WORKS_ICONS.step1,
      iconKey: 'step1' as StepIconKey,
      text: `${html(t('howitworks.steps.step1'))}`
    },
    {
      iconUrl: HOW_IT_WORKS_ICONS.step2,
      iconKey: 'step2' as StepIconKey,
      text: `${html(t('howitworks.steps.step2'))}`
    },
    {
      iconUrl: HOW_IT_WORKS_ICONS.step3,
      iconKey: 'step3' as StepIconKey,
      text: `${html(t('howitworks.steps.step3'))}`
    },
    {
      iconUrl: HOW_IT_WORKS_ICONS.step4,
      iconKey: 'step4' as StepIconKey,
      text: `${html(t('howitworks.steps.step4'))}`
    },
    {
      iconUrl: HOW_IT_WORKS_ICONS.step5,
      iconKey: 'step5' as StepIconKey,
      text: `${html(t('howitworks.steps.step5'))}`
    }
  ]

  return (
    <CustomReveal>
      <Container>
        <Grid>
          <TitleWrapper>
            <Title text={t('howitworks.title')} />
          </TitleWrapper>
          <Buttons>
            <CommonButton
              variant="wrapper"
              className="how-button-prev"
              aria-label={t('a11y.prevSlide')}
              customStyle={BtnGlobalCustomStyles.wrapper}
            >
              <ButtonPrev />
            </CommonButton>
            <CommonButton
              variant="wrapper"
              className="how-button-next"
              aria-label={t('a11y.nextSlide')}
              customStyle={BtnGlobalCustomStyles.wrapper}
            >
              <ButtonNext />
            </CommonButton>
          </Buttons>
          <Swiper
            slidesPerView="auto"
            modules={[Navigation]}
            spaceBetween={40}
            initialSlide={0}
            centeredSlides
            navigation={{
              nextEl: isRTL ? '.how-button-prev' : '.how-button-next',
              prevEl: isRTL ? '.how-button-next' : '.how-button-prev'
            }}
            breakpoints={{
              768: {
                spaceBetween: 35,
                centeredSlides: false
              },
              1280: {
                spaceBetween: 70,
                centeredSlides: false
              },
              1440: {
                spaceBetween: 80,
                centeredSlides: false
              }
            }}
          >
            {steps.map((step, i) => (
              <SwiperSlide key={i}>
                <Content>
                  <IconWrapper>
                    <StepIcon
                      src={step.iconUrl}
                      alt={`Step ${i + 1} icon`}
                      data-step={step.iconKey}
                    />
                  </IconWrapper>
                  <Text1>{step.text}</Text1>
                </Content>
              </SwiperSlide>
            ))}
            <LineWrapper slot="wrapper-end">
              <img
                src={HOW_IT_WORKS_ICONS.line}
                alt="Connection line"
                loading="lazy"
              />
            </LineWrapper>
          </Swiper>
          <InfoText>{t('howitworks.info')}</InfoText>
        </Grid>
      </Container>
    </CustomReveal>
  )
}

export default HowItWorks
